import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import type { ReactNode } from "react";
import { Section } from "~/components/layout/Section";
import { Logo } from "~/components/ui/Logo";
import { Paragraph, Title } from "~/components/ui/Typography";
type FeatureItem = {
  icon?: ReactNode;
  text: string;
};
type StatItem = {
  label: string;
  value: string;
  accent?: string;
};
type PageSplitProps = {
  leftTitle: ReactNode;
  leftDescription: string;
  leftFeatures?: FeatureItem[];
  leftStats?: StatItem[];
  hideHomeLink?: boolean;
  children: ReactNode;
};
export function PageSplit(t0) {
  const $ = _c(33);
  const {
    leftTitle,
    leftDescription,
    leftFeatures: t1,
    leftStats: t2,
    hideHomeLink: t3,
    children
  } = t0;
  let t4;
  if ($[0] !== t1) {
    t4 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const leftFeatures = t4;
  let t5;
  if ($[2] !== t2) {
    t5 = t2 === undefined ? [] : t2;
    $[2] = t2;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const leftStats = t5;
  const hideHomeLink = t3 === undefined ? false : t3;
  let t6;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Logo className="shrink-0 md:hidden" variant="default" />;
    t7 = <Logo className="hidden shrink-0 md:block" variant="light" />;
    $[4] = t6;
    $[5] = t7;
  } else {
    t6 = $[4];
    t7 = $[5];
  }
  let t8;
  if ($[6] !== hideHomeLink) {
    t8 = hideHomeLink ? null : <Link className="rounded-full px-3 py-1.5 text-xs font-medium text-navy transition hover:bg-[rgba(13,35,64,0.06)] hover:text-accent-dark sm:px-4 sm:text-sm" href="/">← Home</Link>;
    $[6] = hideHomeLink;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t8) {
    t9 = <nav className="fixed inset-x-0 top-0 z-50 flex items-center justify-between bg-surface/90 px-4 py-3 backdrop-blur-sm sm:px-6 sm:py-4 md:absolute md:bg-transparent md:py-5 md:backdrop-blur-none md:px-10">{t6}{t7}{t8}</nav>;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  let t11;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_60%_at_20%_80%,rgba(74,174,224,0.14)_0%,transparent_60%),radial-gradient(ellipse_60%_50%_at_80%_20%,rgba(144,213,255,0.07)_0%,transparent_55%)]" />;
    t11 = <div className="absolute inset-0 opacity-[0.18] [background-image:linear-gradient(rgba(144,213,255,0.15)_1px,transparent_1px),linear-gradient(90deg,rgba(144,213,255,0.15)_1px,transparent_1px)] [background-size:44px_44px]" />;
    $[10] = t10;
    $[11] = t11;
  } else {
    t10 = $[10];
    t11 = $[11];
  }
  let t12;
  if ($[12] !== leftTitle) {
    t12 = <Title as="h2" size="section" className="mb-4 text-[#E8F4FF] [&_em]:text-[#90D5FF]">{leftTitle}</Title>;
    $[12] = leftTitle;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  let t13;
  if ($[14] !== leftDescription) {
    t13 = <Paragraph className="mb-8 text-[#90A8C0]">{leftDescription}</Paragraph>;
    $[14] = leftDescription;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== leftFeatures) {
    t14 = leftFeatures.length > 0 ? <div className="flex flex-col gap-3">{leftFeatures.map(_temp)}</div> : null;
    $[16] = leftFeatures;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== leftStats) {
    t15 = leftStats.length > 0 ? <div className="mt-4 flex gap-8">{leftStats.map(_temp2)}</div> : null;
    $[18] = leftStats;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t12 || $[21] !== t13 || $[22] !== t14 || $[23] !== t15) {
    t16 = <aside className="relative hidden overflow-hidden bg-[#071525] md:flex md:flex-col md:justify-center">{t10}{t11}<Section className="py-0" containerClassName="relative z-[1] max-w-[420px]" backgroundClassName="bg-transparent px-12 pt-28 pb-14">{t12}{t13}{t14}{t15}</Section></aside>;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
    $[23] = t15;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== children) {
    t17 = <div className="flex min-h-screen flex-col items-center justify-center bg-surface px-4 pb-8 pt-20 sm:px-6 sm:pt-24 md:min-h-0 md:px-12 md:py-28"><div className="w-full max-w-[420px]">{children}</div></div>;
    $[25] = children;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t16 || $[28] !== t17) {
    t18 = <div className="grid flex-1 md:grid-cols-2">{t16}{t17}</div>;
    $[27] = t16;
    $[28] = t17;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t18 || $[31] !== t9) {
    t19 = <div className="flex min-h-screen flex-col bg-bg text-body">{t9}{t18}</div>;
    $[30] = t18;
    $[31] = t9;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  return t19;
}
function _temp2(stat) {
  return <div key={stat.label} className="text-center"><Title as="h3" size="section" className="text-[28px] leading-none text-[#E8F4FF]">{stat.value}{stat.accent ? <span className="text-[#90D5FF]">{stat.accent}</span> : null}</Title><div className="mt-1 text-[10px] font-semibold uppercase tracking-[0.05em] text-[#7090A8]">{stat.label}</div></div>;
}
function _temp(feature) {
  return <div key={feature.text} className="flex items-center gap-3 rounded-xl border border-[rgba(144,213,255,0.12)] bg-white/[0.04] px-4 py-3">{feature.icon ? <div className="grid h-8 w-8 place-items-center rounded-lg border border-[rgba(74,174,224,0.2)] bg-[rgba(74,174,224,0.12)] text-[#90D5FF]">{feature.icon}</div> : null}<Paragraph className="font-medium text-[#C8E0F4]">{feature.text}</Paragraph></div>;
}